import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/pages/Landing'
import TermsAndConditions from '@/pages/TermsAndConditions'
import SadqahAndAqiqa from '@/pages/SadqahAndAqiqa'
import FAQs from '@/pages/FAQs'
import ContactUs from '@/pages/ContactUs'
import AboutUs from '@/pages/AboutUs'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Dashboard from '@/pages/Dashboard'
import AllPosts from '@/pages/AllPosts'
import NewPost from '@/pages/NewPost'
import UpdatePost from '@/pages/UpdatePost'
import ForgetPassword from '@/pages/ForgetPassword'
import IjtmaeQurbani from '@/pages/IjtmaeQurbani'


Vue.use(Router)
    
export default new Router ({
  mode: 'history',
  routes:[
    {
        path:'/',
        name:'Landing',
        component:Landing
    },
    {
      path:'/update-post',
      name:'UpdatePost',
      component:UpdatePost,
      props:true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:'/ijtmae-qurbani',
      name:'IjtmaeQurbani',
      component:IjtmaeQurbani,
      props:true
    },
    {
      path:'/new-post',
      name:'NewPost',
      component:NewPost,
      props:true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:'/login',
      name:'Login',
      component:Login
    },
    {
      path:'/dashboard',
      name:'Dashboard',
      component:Dashboard,
      props:true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:'/register',
      name:'Register',
      component:Register
    },
    {
      path:'/forget-password',
      name:'ForgetPassword',
      component:ForgetPassword
    },
    {
      path:'/all_posts',
      name:'AllPosts',
      component:AllPosts,
      props:true,
    },
    {
      path:'/terms-and-conditions',
      name:'terms-and-conditions',
      component:TermsAndConditions
    },
    {
      path:'/sadqah-and-aqiqa',
      name:'sadqah-and-aqiqa',
      component:SadqahAndAqiqa
    },
    {
      path:'/terms-and-conditions',
      name:'terms-and-conditions',
      component:TermsAndConditions
    },
    {
      path:'/contact-us',
      name:'contact-us',
      component:ContactUs
    },
    {
      path:'/about-us',
      name:'about-us',
      component:AboutUs
    },
    {
      path:'/faqs',
      name:'faqs',
      component:FAQs
    }

    // {
    //   path:'/searchresults',
    //   name:'searchresults',
    //   component:SearchResults
    // },
    // {
    //   path:'/resultdetails',
    //   name:'resultdetails',
    //   component:ResultDetails
    // }
   ]
})

